// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "gf/css/" + chunkId + "." + "54d7030413ffdfb4dc54" + ".css";
};